// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { carouselStyles } from "@tps/Overrides/Components/ProductCompareCarousel";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.prevArrowGridItem = {
    width: 1,
    align: "top",
    css: css`
        padding-top: 35px;
        position: absolute;
        left: 0;
    `,
};

carouselStyles.prevArrowButton = {
    css: css`
        border: 0;
        padding: 0;
        &, &:hover, &:disabled, &:focus {
            background: none;
            outline: none;
        }
    `,
};

carouselStyles.nextArrowGridItem = {
    width: 1,
    align: "top",
    css: css`
        padding-top: 35px;
        position: absolute;
        right: 0;
    `,
};

carouselStyles.nextArrowButton = {
    css: css`
        border: 0;
        padding: 0;
        &, &:hover, &:disabled, &:focus {
            background: none;
            outline: none;
        }
    `,
};

carouselStyles.carouselGridItem = {
    width: 12,
};

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
        ${xScreen("gt","md")}{
            position: relative;
        }
    `,
};

carouselStyles.carouselContentEmptyCellGridItem = {
    width: [0, 0, 3, 3, 3],
};

carouselStyles.carouselCellGridItem = {
    width: [12, 12, 9, 9, 9],
    css: css`
        padding-bottom: 20px;
    `,
};

carouselStyles.attributeLabelsCellGridItem = {
    width: [6, 6, 3, 3, 3],
};

carouselStyles.attributeValuesCellGridItem = {
    width: [6, 6, 9, 9, 9],
};

carouselStyles.arrowIconStyles = {
    css: css`
        &&& {
            color: ${color("primary.main")};
            &:hover {
                opacity: 1;
                color: ${color("common.ui8")};
            }
        }
    `,
};

carouselStyles.attributeLabelText = {
    ellipsis: true,
    size: 14,
    weight: "bold",
};

carouselStyles.attributeValueText = {
    ellipsis: true,
    size: 14,
};

carouselStyles.attributeValueGridItem = {
    width: 12,
    css: css`
        border-bottom-style: solid;
        border-bottom-width: 1px;
        border-bottom-color: ${({ theme }) => resolveColor("common.border", theme)};
        padding: 0.8rem 0.8rem;
        &:nth-child(even) {
            background-color: ${getColor("common.accent")};
        }
        //XNG-Change
        font-size: 14px;
        justify-content: center;
    `,
};

carouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        padding: 0 20px;
        display: flex;
        justify-content: center;
    `,
};